
const MIN_MS = 300;
const PER_DIGIT_MS = 120;
const MAX_MS = 900;

function digitsIn(delta: number): number {
  const abs = Math.abs(Math.round(delta));
  return abs < 10 ? 1 : Math.floor(Math.log10(abs)) + 1;
}

export function countUpDurationMs(delta: number): number {
  return Math.min(MAX_MS, MIN_MS + digitsIn(delta) * PER_DIGIT_MS);
}
